import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { GoPlus } from "react-icons/go";
import { Link } from "react-router-dom";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import PositionTable from "./positionTable/PositionTable";
import { getHistoryLogin } from "../apifile/ApiFiles";
import { Pagination } from "antd";
import { Loaders } from "../../pages/Loaders";

function HistoryList() {
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  const [page, setPage] = useState(0)
  const [count, setCount] = useState(10)
  const [total, setTotal] = useState(0);
  const getData = async (pageVal = 0) => {
    setLoad(true)
    try {
      const res = await getHistoryLogin({ page: pageVal, count });
      const result = res?.data?.data;
      setData(result?.data || []);
      setTotal(result?.total || 0);
      setPage(result?.page || 0);
    } catch (error) {
    }
    setLoad(false)
  }
  useEffect(() => {
    getData(0)
  }, [])
  const onChangeVal = (pageNumber) => {
    getData(pageNumber - 1);
  }
  return (
    <div className="pageTableWrapper">
      {load && <Loaders />}
      <div className="pageHeader">
        <div className="pageTitle">
          <FiSettings />
          <h5>Login History</h5>
        </div>
      </div>

      <div className="pageBody">
        <PositionTable data={data} />
      </div>

      <div className="pageFooter mt-3">
        <div className="row">
          <div className="col-md-6">
            Showing {data?.length} of {total} records
          </div>
          <div className="col-md-6">
            <div className="paginationPart">
              <Pagination
                onChange={onChangeVal}
                current={page + 1}
                pageSize={count}
                total={total}
                showSizeChanger={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryList;
